<div class="search-toolbar">
    <span>{{'LAYOUT.SEARCH.HIDE' | translate}}&nbsp;<kbd>ESC</kbd></span>
    <span>{{'LAYOUT.SEARCH.SHOW' | translate}}&nbsp;<kbd>CTRL</kbd>&nbsp;<kbd>SHIFT</kbd>&nbsp;<kbd>F</kbd></span>
    <span>{{'LAYOUT.SEARCH.FILTER' | translate}}&nbsp;<kbd>ENTER</kbd></span>
</div>
